import React from 'react';
import { Switch } from '@/components/ui/switch';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import InlineEdit from '@/components/taxonomy/InlineEdit';

export const CLASS_LABEL = { positive_driver: 'Positive Driver', gap: 'Gap' };
export const CLASS_TONE = {
  positive_driver: 'text-[#1F684A] bg-[#EDF8F2] border-[#CDE9DA]',
  gap: 'text-[#A1272E] bg-[#FFF0F0] border-[#F0C6C9]',
};

export function ClassificationPill({ value }) {
  return <span className={`inline-flex text-[11px] font-semibold border rounded-full px-2 py-0.5 ${CLASS_TONE[value]}`}>{CLASS_LABEL[value]}</span>;
}

export default function FactorRow({ factor, canEdit, onUpdate }) {
  const id = factor.factor_id;
  const active = factor.status === 'active';
  return (
    <div className={`flex items-center gap-3 py-2.5 border-b border-[#F1F5F9] last:border-0 ${active ? '' : 'opacity-60'}`} data-testid={`factor-row-${id}`}>
      <InlineEdit value={factor.name} canEdit={canEdit} onSave={(name) => onUpdate(id, { name })} className="flex-1 text-sm text-[#0F172A]" testId={`factor-name-${id}`} />
      {canEdit ? (
        <Select value={factor.classification} onValueChange={(v) => onUpdate(id, { classification: v })}>
          <SelectTrigger className={`h-7 w-[150px] text-xs font-semibold border ${CLASS_TONE[factor.classification]}`} data-testid={`factor-class-${id}`}><SelectValue /></SelectTrigger>
          <SelectContent>
            <SelectItem value="positive_driver" data-testid={`factor-class-option-positive-${id}`}>Positive Driver</SelectItem>
            <SelectItem value="gap" data-testid={`factor-class-option-gap-${id}`}>Gap</SelectItem>
          </SelectContent>
        </Select>
      ) : <ClassificationPill value={factor.classification} />}
      <label className="flex items-center gap-2 text-[11px] text-[#64748B] w-[78px] justify-end">
        {active ? 'Active' : 'Inactive'}
        <Switch checked={active} disabled={!canEdit} onCheckedChange={(v) => onUpdate(id, { status: v ? 'active' : 'inactive' })} data-testid={`factor-status-${id}`} />
      </label>
    </div>
  );
}
